define ['./create_name.css'], () ->
  randomize = require('randomatic')
  ($scope, $http, $state, RentappService, RENTAPPLICATION_API_URL, INFO_PAGE_SLUGS, $rootScope, $cookies) ->
    $scope.data = $scope.data or {}
    $scope.highlighted = false

    $scope.creating_form = false

    if !$scope.data.selected_report_sources
      $state.go "root.forms.select_reports"

    if not $scope.data.slug
      RentappService.getMe().then (user) ->
        temp_slug = user.email.split('@')[0].replace(/[^A-Z0-9]+/ig, '')
        if temp_slug.length < 6
          $scope.random_slug()
          return
        $http.get("#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/check_available/", { params: { slug: temp_slug } })
        .then (response) ->
          if response.data.available
            $scope.data.slug = temp_slug
          else
            $scope.random_slug()

    $scope.random_slug = () ->
      $scope.data.slug = randomize('a0', 6)
      $scope.highlighted = true

    $scope.create_new_form = () ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/create_default/",
        data: $scope.data
      .then (response) ->
        $rootScope.$broadcast("forms-changed")

        if response.data.first_template
          $cookies.put("just_created_first_form", true)

        $state.go("root.dashboard.forms")

      .catch (error)->
        console.log(error)
      .finally () ->
        $scope.creating_form = false

    $scope.go_back = () ->
      $state.go "root.forms.select_reports"

    $scope.go_next_page = () ->
      if $scope.form_slug.$valid
        $scope.check_available()
      else
        $scope.error_message = "Invalid URL link. Your link can only contain a combination of letters, numbers, underscores and hyphens."

    $scope.check_available = () ->
      if $scope.data.slug.length < 6
        $scope.error_message = "URL link must be at least 6 characters long"
        return
      if /^\d+$/.test($scope.data.slug)
        $scope.error_message = "URL link must contain at least one letter"
        return
      if $scope.data.slug in INFO_PAGE_SLUGS
        $scope.error_message = "URL link is already taken, please try another"
        return
      $scope.creating_form = true
      $http.get("#{RENTAPPLICATION_API_URL}/api/v1/applicationtemplate/check_available/", { params: { slug: $scope.data.slug } })
        .then (response) ->
          if response.data.available
            $scope.create_new_form()
          else
            $scope.creating_form = false
            $scope.error_message = "URL link is already taken, please try another"



// WEBPACK FOOTER //
// ./components/forms/create_name/create_name.coffee